import React from 'react';
import {Formatted, Video} from 'components';
import {config} from 'helpers';

export function Values() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.identity.values} />
      <div className="medium-spacing">
        <p>Your core values define who you are, what you believe in and what you stand for. You may be aware of them and you may not, but your core values come to play in every aspect of your life.</p>
        <p>Values range from the commonplace like hard work and honesty, to more the philosophical, like justice and honor. Being fully aware of your values will bring a strong sense of clarity and focus into your life.</p>
        <p>Think of your values as a life compass. When you live your values, you make consistent decisions and take determined action in the areas that are most important to you, bringing increased energy and flow to life. If you make decisions or do things that clash with your values, you feel resistance and conflict.</p>
        <p>You uncover your values by looking inside yourself, examining your past and present behaviors, and searching for your inner truth. The following inquiries will help you explore your values.</p>
      </div>
    </Formatted>
  );
}
